module.exports = __webpack_public_path__ + "static/media/Openflo@2x.78e0b9a7.png";